<div class="wrapper">
  <div class="action-section flex flex-row-reverse my-[20px] w-full gap-[20px]">
    @if (isPM()) {
      <app-primary-button (handleClick)="createPackage()" class="!w-[180px]">
        Create Package
      </app-primary-button>
    }

    <div class="pkg-filters flex flex-row gap-[20px] flex-1 mt-[7px]">
      <app-status-filter [statusOptions]="statusList" />
      <div>
        @if (selectedSortColumn) {
          <mat-form-field class="sort-dropdown">
            <mat-select
              (selectionChange)="onSortColumnChange($event)"
              [(value)]="selectedSortColumn"
              disableOptionCentering
              panelClass="claim-sort-panel">
              <mat-select-trigger>
                Sort by: {{ selectedSortColumn }}
              </mat-select-trigger>
              @for (column of sortByColumns; track column) {
                <mat-option [value]="column">{{ column }}</mat-option>
              }
            </mat-select>
            <mat-icon (click)="removeSort($event)" class="sort-close" matSuffix>close</mat-icon>
          </mat-form-field>
        }
        @if (!selectedSortColumn) {
          <div (click)="openSortDropdown($event)" class="sort-dropdown nosort">
            <div class="label text-type-8">Sort:</div>
            <mat-icon>sync_alt</mat-icon>
            <mat-form-field class="sr-sort-hidden">
              <mat-select
                #sortSelect
                (selectionChange)="onSortColumnChange($event)"
                [(value)]="selectedSortColumn"
                disableOptionCentering
                panelClass="claim-sort-panel">
                @for (column of sortByColumns; track column) {
                  <mat-option [value]="column">{{ column }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
        }
      </div>
      <div class="search-section flex flex-1 flex-row gap-[10px] min-w-0">
        <form [formGroup]="form" class="flex-1 min-w-0">
          <div class="search w-full">
            <mat-icon svgIcon="search"></mat-icon>
            <input
              class="search-input"
              formControlName="searchText"
              matInput
              placeholder="Search"
            />
            @if (form?.controls?.['searchText']?.value) {
              <mat-icon (click)="clearSearch()" svgIcon="close"></mat-icon>
            }
          </div>
        </form>
      </div>
    </div>
  </div>

  <div class="packages-list flex flex-col">
    @if (packages.length) {
      <!-- Table header -->
      <div class="pkg-table-header flex items-center py-[12px] border-b border-[#E9ECF4]">
        <div class="col-package flex-[2] text-type-13 uppercase text-[#60698B]">Packages / Claims</div>
        <div class="col-status flex-1 text-type-13 uppercase text-[#60698B]">Status</div>
      </div>

      @for (pkg of packages; track pkg.id) {
        <!-- Package row -->
        <div class="pkg-row border-b border-[#E9ECF4]">
          <div class="pkg-header flex items-center py-[14px] cursor-pointer"
               [class.expanded]="pkg._expanded"
               (click)="rowClicked(pkg)">
            <div class="col-package flex-[2]">
              <div class="flex items-center gap-[8px]">
                <mat-icon class="expand-chevron text-[#60698B] cursor-pointer"
                          style="font-size:20px;width:20px;height:20px;"
                          (click)="toggleExpand(pkg, $event)">
                  {{ pkg._expanded ? 'expand_more' : 'chevron_right' }}
                </mat-icon>
                <div>
                  <div class="text-type-8 font-medium">
                    {{ pkg.package_number }}{{ pkg.title ? ' - ' + pkg.title : '' }}
                  </div>
                  <div class="text-type-14 text-[#60698B]">{{ pkg.claim_count || 0 }} claims</div>
                </div>
              </div>
            </div>
            <div class="col-status flex-1 flex items-center justify-between">
              <div>
                @if (pkg.status && statusMap[pkg.status]) {
                  <div
                    [ngClass]="[statusMap[pkg.status].bgColor, statusMap[pkg.status].textColor]"
                    class="status-chip px-[14px] rounded-full inline-block">
                    {{ statusMap[pkg.status].label }}
                  </div>
                }
              </div>
              <button [matMenuTriggerFor]="moreMenu"
                      (click)="$event.stopPropagation()"
                      class="more-menu-button"
                      aria-label="More options">
                <mat-icon>more_horiz</mat-icon>
              </button>
              <mat-menu #moreMenu="matMenu">
                @if (pkg.status !== 'draft') {
                  <button mat-menu-item (click)="downloadPdf(pkg)">
                    <mat-icon>picture_as_pdf</mat-icon>
                    <span>PDF Report</span>
                  </button>
                  <button mat-menu-item (click)="downloadCsv(pkg)">
                    <mat-icon>table_chart</mat-icon>
                    <span>CSV Export</span>
                  </button>
                  <button mat-menu-item (click)="downloadKmz(pkg)">
                    <mat-icon>map</mat-icon>
                    <span>KMZ Map File</span>
                  </button>
                }
                @if (pkg.status === 'draft' && isPM()) {
                  <button mat-menu-item (click)="deletePackage(pkg)">
                    <mat-icon class="text-red-500">delete</mat-icon>
                    <span class="text-red-500">Delete</span>
                  </button>
                }
              </mat-menu>
            </div>
          </div>

          <!-- Expanded claims -->
          @if (pkg._expanded) {
            <div class="pkg-claims pl-[40px] pb-[12px]">
              @if (pkg._claimsLoading) {
                <div class="text-type-14 text-[#60698B] py-[8px]">Loading claims...</div>
              } @else if (pkg._claims?.length) {
                @for (claim of pkg._claims; track claim.id) {
                  <div class="claim-row flex items-center py-[10px] border-t border-[#F0F1F5] cursor-pointer"
                       (click)="claimClicked(claim, $event)">
                    <div class="col-package flex-[2]">
                      <div class="text-type-11 font-medium">{{ claim.claim_number }} - {{ claim.title }}</div>
                      @if (claim.claim_type || claim.defect_type) {
                        <div class="text-type-14 text-[#60698B]">
                          {{ claim.claim_type }}{{ claim.defect_type ? ' / ' + claim.defect_type : '' }}
                        </div>
                      }
                    </div>
                    <div class="col-status flex-1">
                      <div class="flex items-center gap-[6px]">
                        @if (claim.severity && severityMap[claim.severity]) {
                          <span
                            [ngClass]="[severityMap[claim.severity].bgColor, severityMap[claim.severity].textColor]"
                            class="severity-chip px-[8px] rounded-full text-[11px]">
                            {{ severityMap[claim.severity].label }}
                          </span>
                        }
                        @if (claim.status && claimStatusMap[claim.status]) {
                          <span class="flex items-center gap-[4px] text-type-14">
                            <span [style.color]="claimStatusMap[claim.status].iconColor">{{ claimStatusMap[claim.status].icon }}</span>
                            {{ claimStatusMap[claim.status].label }}
                          </span>
                        }
                      </div>
                    </div>
                  </div>
                }
              } @else {
                <div class="text-type-14 text-[#60698B] py-[8px]">No claims in this package.</div>
              }
            </div>
          }
        </div>
      }
    }

    @if (!packages.length) {
      <div class="no-data text-type-8 mt-[80px]">No claim packages found.</div>
    }

    <app-paginator
      (pageChanged)="onPageChanged($event)"
      [itemsPerPage]="pagination.pageSize"
      [maxVisiblePages]="5"
      [totalItems]="totalRecords"
      class="paginator"
    />
  </div>
</div>
